export default "__VITE_ASSET__CR$gxW7i__"